import { CompaniesState } from '$store/modules/companies';
import { SeniorityLevelType } from '$types/position/positionPropertyValues';
import { seniorityToExpYears } from '$utils/seniorityToExpYears';

type FormState = CompaniesState['employerAddPositionForm'];

const JSON_FIELDS = [
  'JobPosition',
  'RequiredSkills',
  'NiceToHaveSkills',
  'Languages',
  'Company',
];

export const buildPositionPayload = (
  form: FormState,
  currencyToUsdConverter: (n: number) => number,
  internalFields: Record<string, any> = {}
): Record<string, any> => {
  const {
    SeniorityLevel,
    jobTitle,
    JobPosition,
    jobIsntListed,
    customJobType,
    SalaryLowerBound,
    SalaryUpperBound,
    IdealStartDate,
    NiceToHaveSkills,
    RequiredSkills,
    Responsibilities,
    TypeOfWork,
    Languages,
    WorkLocation,
    JobDescription,
    DegreeType,
    WorkingHours,
    WorkingDays,
    bonus,
    BonusDetails,
    commission,
    CommissionDetails,
    benefits,
    BenefitsDetails,
    other,
    OtherCompensation,
    Country,
    FeeAmount,
  } = form;

  return {
    ...(WorkingHours && { WorkingHours }),
    ...(WorkingDays && { WorkingDays }),
    ExperienceYears: seniorityToExpYears(SeniorityLevel),
    /* This field is required by the backend */
    Skills_position: [],
    SeniorityLevel: SeniorityLevel as SeniorityLevelType,
    ...(!jobIsntListed
      ? { JobPosition }
      : { IsCustomPosition: true, CustomJobTitle: customJobType }),
    ...(bonus && { BonusDetails }),
    ...(commission && { CommissionDetails }),
    ...(benefits && { BenefitsDetails }),
    ...(other && { OtherCompensation }),
    ...(jobTitle && { Name: jobTitle }),
    ...(WorkLocation && { WorkLocation }),
    ...(Country && { Country }),
    SalaryLowerBound: currencyToUsdConverter(SalaryLowerBound),
    SalaryUpperBound: currencyToUsdConverter(SalaryUpperBound),
    IdealStartDate,
    NiceToHaveSkills,
    RequiredSkills,
    Responsibilities,
    TypeOfWork,
    ...(JobDescription && { JobDescription }),
    ...(DegreeType && { DegreeType }),
    ...(Languages &&
      Languages.length > 0 && {
        Languages: Languages.map((languageId: number) => ({
          languageId,
          IsRequired: true,
        })),
      }),
    ...(FeeAmount != null && { FeeAmount }),
    ...internalFields,
  };
};

export const buildPositionFormData = (
  payload: Record<string, any>,
  file?: File | null
): FormData => {
  const formData = new FormData();
  if (file) formData.append('JobDescriptionFile', file);
  Object.keys(payload).forEach((singleProp) => {
    if (payload[singleProp] == null) return;
    if (JSON_FIELDS.includes(singleProp)) {
      formData.append(singleProp, JSON.stringify(payload[singleProp]));
    } else {
      formData.append(singleProp, String(payload[singleProp]));
    }
  });
  return formData;
};
